<div class="td col-number layout-column layout-align-center-start">
  <div class="layout-row layout-align-start-center gap-5">
    <a class="br-link-1 text-ellipsis" appBringozIdGenerator="threepl-vouchers-row-number-link" (click)="voucherSelect.emit(voucher())">
      <span class="br-body-2">{{ title() }}</span>
    </a>
    @if (comments().length) {
      <span container="body" [ngbTooltip]="commentsText()" placement="right">
        <bz-icon class="threepl-voucher-comments-icon" [icon]="icons.comments" size="lg"></bz-icon>
      </span>
    }
  </div>
  <span class="br-body-2 text-ellipsis">{{ voucher().externalId }}</span>
</div>

<div class="td col-external-id">
  <span class="br-body-2 text-ellipsis">{{ voucher().threePlExtraData?.voucherId || '---' }}</span>
</div>

<div class="td col-created-at">
  <span class="br-body-2 text-ellipsis">{{ voucher() | bringozFullDate: 'createdAt' }}</span>
</div>

<div class="td col-status">
  <bz-tag [tone]="voucher().status | threeplStatusTone">{{ voucher().status | translate }}</bz-tag>
</div>

<div class="td col-train-status"></div>

<div class="td col-loading-date">
  <span class="br-body-2 text-ellipsis">{{ voucher().displayName }}</span>
</div>

<div class="td col-origin layout-column layout-align-center-start">
  <div class="layout-row layout-align-start-center">
    <bz-icon class="margin-right-5 voucher-location-icon" [icon]="icons.depot"></bz-icon>
    <!-- ui-fallback: depot link stays an admin component. Guarded: unlike the AngularJS one it throws on a missing depot. -->
    @if (voucher().threePlExtraData?.pickupDepot; as depot) {
      <app-depot-link [depot]="depot"></app-depot-link>
    }
  </div>
  @if (voucher().threePlExtraData?.pickupTrainStation?.description) {
    <div class="layout-row layout-align-start-center">
      <bz-icon class="margin-right-5 voucher-location-icon" [icon]="icons.station"></bz-icon>
      <span class="br-body-2 text-ellipsis">{{ voucher().threePlExtraData.pickupTrainStation.description }}</span>
    </div>
  }
</div>

<div class="td col-destination layout-column layout-align-center-start">
  <div class="layout-row layout-align-start-center">
    <bz-icon class="margin-right-5 voucher-location-icon" [icon]="icons.depot"></bz-icon>
    <!-- ui-fallback: depot link stays an admin component. Guarded: unlike the AngularJS one it throws on a missing depot. -->
    @if (voucher().threePlExtraData?.destinationDepot; as depot) {
      <app-depot-link [depot]="depot"></app-depot-link>
    }
  </div>
  @if (voucher().threePlExtraData?.destinationTrainStation?.description) {
    <div class="layout-row layout-align-start-center">
      <bz-icon class="margin-right-5 voucher-location-icon" [icon]="icons.station"></bz-icon>
      <span class="br-body-2 text-ellipsis">{{ voucher().threePlExtraData.destinationTrainStation.description }}</span>
    </div>
  }
</div>

<div class="td col-total-cars">
  <span class="br-body-2 text-ellipsis">{{ voucher().threePlExtraData?.totalCars }}</span>
</div>

<div class="td col-total-weight">
  <span class="br-body-2 text-ellipsis">{{ voucher().threePlExtraData?.totalWeight }}</span>
</div>

<div class="td col-row-actions">
  <bz-menu appBringozIdGenerator="threepl-vouchers-row-actions-menu"
           [ariaLabel]="'Fulfillment actions' | translate"
           [items]="[
             {id: 'complete', label: ('Complete' | translate)},
             {id: 'cancel', label: ('Cancel' | translate)},
             {id: 'print', label: ('Print' | translate)}
           ]"
           (selected)="onMenuSelected($event)">
    <bz-icon class="voucher-actions-icon" [icon]="icons.menu"></bz-icon>
  </bz-menu>
</div>
